import React from "react"
import { useScheduledTaskReportExportContext } from "contexts/ScheduledTaskReportExportContext"
import { ListSelect } from "shared/selects"
import {
  dayjsOrgTz, DAYS, MONTHS, WEEKS,
} from "utils/dateHelpers"
import { tasksHeaderCopyByDateFilterType } from "utils/scheduledReportExportHelpers"
import DaysTaskDateDescription from "./TaskDateDescriptions/DaysTaskDateDescription"
import WeeksTaskDateDescription from "./TaskDateDescriptions/WeeksTaskDateDescription"
import MonthsTaskDateDescription from "./TaskDateDescriptions/MonthsTaskDateDescription"

const ScheduledTaskReportExportTaskDateFilters = () => {
  const {
    dateFilterType,
    lengthOptions,
    setTaskPreviousRangeLength,
    startDate,
    taskPreviousRangeLength,
    taskPreviousRangeUnit,
  } = useScheduledTaskReportExportContext()

  return (
    <>
      <div className="flex items-center my-4">
        <span className="required-prompt">{tasksHeaderCopyByDateFilterType(dateFilterType)}</span>
        <ListSelect
          className="bordered-base-input ml-2 max-w-max"
          clearable={false}
          backspaceDelete={false}
          placeholder="1"
          name="task_previous_range_length"
          required
          options={lengthOptions}
          value={taskPreviousRangeLength}
          onChange={setTaskPreviousRangeLength}
          label={`select number of ${taskPreviousRangeUnit}`}
        />
        <div className="ml-2">{taskPreviousRangeUnit}</div>
      </div>

      {
        taskPreviousRangeUnit === DAYS
        && (
          <DaysTaskDateDescription
            // DateInput sets value as a string
            startDate={dayjsOrgTz(startDate, "YYYY-MM-DD")}
            taskPreviousRangeLength={taskPreviousRangeLength}
            dateFilterType={dateFilterType}
          />
        )
      }
      {
        taskPreviousRangeUnit === WEEKS
        && (
          <WeeksTaskDateDescription
            startDate={startDate}
            taskPreviousRangeLength={taskPreviousRangeLength}
            dateFilterType={dateFilterType}
          />
        )
      }
      {
        taskPreviousRangeUnit === MONTHS
        && (
          <MonthsTaskDateDescription
            startDate={startDate}
            taskPreviousRangeLength={taskPreviousRangeLength}
            dateFilterType={dateFilterType}
          />
        )
      }
    </>
  )
}

export default ScheduledTaskReportExportTaskDateFilters
